// hooks/Cases/useCaseListPersistence.ts
import { useEffect, useRef, useState } from "react";
import { useCaseListContext } from "../../context/CaseListContext";
import { PersistedState } from "../../types/CaseListTypes";
import { STORAGE_KEY } from "../../components/shared/helpers/helper";

export const useCaseListPersistence = () => {
  const {
    filters,
    setFilters,
    sort,
    setSort,
    searchValue,
    setSearchValue,
    page,
    setPage,
    list,
    setList,
    noOfPages,
    setnoOfPages,
    getDefaultFilters,
  } = useCaseListContext();

  const [isHydrated, setIsHydrated] = useState(false);
  const isInitialMount = useRef(true);

  // Load from localStorage on mount
  useEffect(() => {
    if (isInitialMount.current) {
      const savedState = localStorage.getItem(STORAGE_KEY);
      if (savedState) {
        try {
          const parsed: PersistedState = JSON.parse(savedState);
          setFilters(parsed.filters || []);
          setSort(parsed.sort || { value: null, type: "ASC" });
          setSearchValue(parsed.searchValue || "");
          setPage(parsed.page || 1);
          setList(parsed.list || []);
          setnoOfPages(parsed.noOfPages || 0);
        } catch (err) {
          console.error("Failed to parse saved state:", err);
        }
      } else {
        // No saved state - apply default filters
        const defaultFilters = getDefaultFilters();
        setFilters(defaultFilters);
      }
      setIsHydrated(true);
      isInitialMount.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run on mount

  // Save to localStorage whenever relevant state changes
  useEffect(() => {
    if (!isHydrated) return;

    const stateToSave: PersistedState = {
      filters,
      sort,
      searchValue,
      page,
      list,
      noOfPages,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, sort, searchValue, page, list, noOfPages]);

  return {
    isHydrated,
  };
};
